import type {$Fetch} from "nitropack";

export enum StatisticalType {
    NewContracts = 'new_contracts',
    NewContractsSend = 'new_contracts_send',
    ExpectedGains = 'expected_gains',
}

interface GetStatisticalQueryParams {
    start_time?: Date;
    end_time?: Date;
    type: StatisticalType;
}

interface StatisticalResponse {
    count: number;
    object: string;
    start_time?: Array<unknown>;
    end_time?: Array<unknown>;
    type: StatisticalType;
}

export const MissionStatisticalRepository = (client: $Fetch) => ({
    fetch: (params: GetStatisticalQueryParams) => {
        // Build query params
        const queryParams = new URLSearchParams();

        const now = new Date();

        // Convert dates to ISO 8601 format (standard format)
        // If params.start_time/end_time are undefined, use current date
        const startTime = params.start_time ? new Date(params.start_time) : now;
        const endTime = params.end_time ? new Date(params.end_time) : now;

        queryParams.append('start_time', startTime.toISOString().slice(0, 10));
        queryParams.append('end_time', endTime.toISOString().slice(0, 10));
        queryParams.append('category', params.type || '');

        const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';

        return client(`/v1/missions/statistics${queryString}`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "accept": "application/json"
            }
        }) as Promise<StatisticalResponse>;
    },
})